/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetAccess } from "./SheetAccess";
import { Property } from "../../property/types/Property";
import { Action } from "../../commons/types/Action";
import { SheetConstraint } from "./SheetConstraint";
import { SheetTreatments } from "./SheetTreatments";
export const SheetConfig = core.serialization.object({
    name: core.serialization.string(),
    description: core.serialization.string().optional(),
    slug: core.serialization.string().optional(),
    readonly: core.serialization.boolean().optional(),
    allowAdditionalFields: core.serialization.boolean().optional(),
    mappingConfidenceThreshold: core.serialization.number().optional(),
    access: core.serialization.list(SheetAccess).optional(),
    fields: core.serialization.list(Property),
    actions: core.serialization.list(Action).optional(),
    metadata: core.serialization.any().optional(),
    constraints: core.serialization.list(SheetConstraint).optional(),
    treatments: core.serialization.list(SheetTreatments).optional(),
    collection: core.serialization.string().optional(),
});
